import { useContext } from 'react'
import { AuthContext } from '@/contexts/AuthContext'
import { User } from '@/types/User'
import { AuthUser } from '@/api/auth/types'

type UpdateInfoPayload = Partial<Omit<AuthUser, 'id' | 'name' | 'email_verified'>> & {
  old_password?: string
  redirect_path?: string
}

interface UseAuthReturn {
  user: User | undefined
  isAuthenticated: boolean
  isLocked: boolean
  login: (username: string, password: string) => Promise<void>
  loginSso: (code: string) => Promise<void>
  loginWithBiometric: () => Promise<void>
  hasStoredRefresh: () => Promise<boolean>
  updateTokens: (access: string, refresh: string) => Promise<void>
  updateInfo: (newUser: UpdateInfoPayload) => Promise<void>
  updatePassword: (currentPassword: string, newPassword: string) => Promise<void>
  refreshUser: () => void
  deleteAccount: () => Promise<void>
  logout: () => Promise<void>
  isLoading: boolean
}

export const useAuth = (): UseAuthReturn => {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }

  return context
}
